import React, { FC, ReactNode, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Footer from "../components/footer";
import Grid from "../components/grid";
import Header, { HeaderButton, HeaderMobileMenu, LocalizationButton } from "../components/header";
import { HeaderLink } from "../components/footer";
import { FullScreenModal } from "../components/modal/fullScreenModal";
import { FullScreenMenu } from "../components/modal/menu";
import { FormattedMessage } from "react-intl";

const DesktopOnly: FC<{ children: ReactNode }> = ({ children }) => {
    const query = "(min-width: 1024px)";
    const [matches, setMatches] = useState(window.matchMedia(query).matches);

    useEffect(() => {
        window.matchMedia(query).addEventListener("change", (e) => setMatches(e.matches));
    }, []);
    return matches ? <>{children}</> : null;
};

const MobileOnly: FC<{ children: ReactNode }> = ({ children }) => {
    const query = "(max-width: 1024px)";
    const [matches, setMatches] = useState(window.matchMedia(query).matches);

    useEffect(() => {
        window.matchMedia(query).addEventListener("change", (e) => setMatches(e.matches));
    }, []);
    return matches ? <>{children}</> : null;
};

const AppLayout: FC = () => {
    const [isShown, setIsShown] = useState(false);
    return (
        <Grid>
            <Header>
                <DesktopOnly>
                    <HeaderLink to='/#product'>
                        <FormattedMessage id='header.products' />
                    </HeaderLink>
                    <HeaderLink to='/blog'>
                        <FormattedMessage id='header.blog' />
                    </HeaderLink>
                    {/* <LocalizationButton />*/}
                    <HeaderButton to='/#demo'>
                        <FormattedMessage id='header.conversion_button' />
                    </HeaderButton>
                </DesktopOnly>
                <MobileOnly>
                    <HeaderMobileMenu onClick={() => setIsShown(true)} />
                    <FullScreenModal show={isShown}>
                        <FullScreenMenu onClose={() => setIsShown(false)} />
                    </FullScreenModal>
                </MobileOnly>
            </Header>
            <Outlet />
            <Footer />
        </Grid>
    );
};

export default AppLayout;
